module.exports = __webpack_public_path__ + "img/formatador_unico_img3.a64cb25c.jpg";